module.exports = __webpack_public_path__ + "static/youtube-7c13003654cdda9aa75a03b0da0a2bcc.png";